export function defaultTagsFilter(tags) {
  const result = [];
  for (const tag of tags) {
    if (tag.sourceId) {
      for (const group of tag.groups) {
        if (group.sourceId.startsWith('browser_')) {
          result.push(group);
        }
      }
    }
  }
  return result;
};

export function languageBasedDefaultTagIdProvider(allAvailableTags) {
  let language = document.documentElement.lang;
  let languageSourceId;
  switch (language) {
    case 'it':
      languageSourceId = 'italian';
      break;
    case 'fr':
      languageSourceId = 'french';
      break;
    default:
      languageSourceId = 'german';
      break;
  }
  const filteredGroups = allAvailableTags.filter(tagGroup => tagGroup.sourceId === languageSourceId);
  const result = [];
  for (const filteredGroup of filteredGroups) {
    const subGroups = filteredGroup.groups.filter((group) => group.sourceId.startsWith('browser_'));
    const bluewinTags = [];
    subGroups.forEach((subGroups) => {
      subGroups.tags.forEach((tag) => {
        if (tag.sourceId.includes('breakingnews') || tag.sourceId.includes("sports") || tag.sourceId.includes("bigstories")) {
          bluewinTags.push(tag)
        }
      });
    });
    bluewinTags.forEach(tag => result.push(tag.id))
  }
  return result;
}

export function tagFormatter(config) {
  let newConfig = config
  if(Array.isArray(newConfig.app.client.defaultSubscribedTags)) {
    return newConfig;
  }

  let tags = newConfig.app.client.defaultSubscribedTags.split(/\s*,\s*/g).map(e => Number(e) || e);
  newConfig.app.client.defaultSubscribedTags = tags;
  return newConfig;
}

export function showElement(elementId, display) {
  if (document.getElementById(elementId)) {
    let element = document.getElementById(elementId);
    if (!display) {
      display = 'block';
    }
    element.style.display = display;
  }
}

export function hideElement(elementId) {
  if (document.getElementById(elementId)) {
    let element = document.getElementById(elementId);
    element.style.display = 'none';
  }
}

export function userAgent() {
  const ua = navigator.userAgent;
  let browser;
  if (ua.indexOf('Chrome') > -1) {
    browser = 'chrome';
  } else if (ua.indexOf('Firefox') > -1) {
    browser = 'firefox';
  } else if (ua.indexOf('Safari') > -1) {
    browser = 'safari'
  }
  return browser;
}


export const loadScript = (url) => new Promise((resolve, reject) => {
  const script = document.createElement("script");
  script.src = url;
  document.head.appendChild(script);
  script.onreadystatechange = resolve;
  script.onload = resolve;
})

export const loadStyle = (url) => {
  const link = document.createElement("link");
  link.rel = 'stylesheet';
  link.href = url;
  document.head.appendChild(link);
}

export const unregisterServiceWorkers = () => {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister()
    }
  });
  caches.keys().then(keyList => {
    return Promise.all(
      keyList.map(key => {
        return caches.delete(key);
      }),
    );
  });
}

/**
 * create absolute urls based on script location or just return the url if it's already absolute
 * 
 * @param {String} url
 * @return {String}  
 */
export const absoluteUrl = (url) => {
  const thisSrc = document.querySelector("script[src$='webpush.js']").src;
  const basePath = thisSrc.substring(0, thisSrc.lastIndexOf("/"));
  if (url && url.startsWith('http')) {
    return url;
  }
  else {
    return `${basePath}/${url}`;
  }
}